export default "__VITE_ASSET__BuG14yT1__"